import { useEffect, useState } from "react";
import $ from "jquery";
import { event } from "jquery";
import { Controller, useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import {
  actionEmployerAdd,
  resetEmployerAdd,
  actionZoneList,
  resetZoneList,
  resetEmployerUpdate,
  actionEmployerUpdate,
} from "../../routes/app/auth/list/store";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";

const EmployerAddEdit = (props) => {
  const [zoneDropdown, setZoneDropdown] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedZoneId, setSelectedZoneId] = useState([]);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    control,
  } = useForm();

  const { ZoneList, EmployerUpdate, EmployerAdd } = useSelector((state) => ({
    ...state.listStore,
  }));

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
      dispatch(actionZoneList());
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    if (props.employerData) {
      Object.keys(props.employerData).forEach((key) =>
        setValue(key, props.employerData[key])
      );
      setValue("status", props?.employerData?.status);
      setValue("is_superuser", props?.employerData?.is_superuser);
    }
  }, [props.employerData]);

  useEffect(() => {
    if (props?.zoneIds && props?.zoneIds !== null) {
      setValue("zone_ids", props?.zoneIds);
    }
  }, [props?.zoneIds]);

  useEffect(() => {
    if (EmployerUpdate) {
      dispatch(resetEmployerUpdate());
      $("#add_edit_employer").prop("disabled", false);
      if (EmployerUpdate.status === true) {
        setLoading(false)
        toast.success(EmployerUpdate.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        // toast.error(EmployerUpdate?.message, {
        //   duration: TOAST_DURATION,
        //   position: TOAST_POSITION,
        //   style: {},
        // });
      }
    }
  }, [EmployerUpdate]);

  useEffect(() => {
    if (ZoneList) {
      dispatch(resetZoneList());
      if (ZoneList.status) {
        setZoneDropdown(ZoneList.data);
      }
    }
  }, [ZoneList]);

  useEffect(() => {
    if (EmployerAdd) {
      dispatch(resetEmployerAdd());
      $("#add_edit_employer").prop("disabled", false);
      if (EmployerAdd.status === true) {
        setLoading(false)
        toast.success(EmployerAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(EmployerAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_ERROR_COLOR,
          },
        });
      }
    }
  }, [EmployerAdd]);

  const zoneOptions = zoneDropdown.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const onSubmit = (data) => {
    data.is_superuser = data?.is_superuser ? 1 : 0;
    if (props.employerData) {
      delete data.employerZones;
      data.id = props.employerData?.id;
      $("#add-edit-employer-loader").removeClass("hidden");
      $("#add_edit_employer").prop("disabled", true);
      dispatch(actionEmployerUpdate({ id: props.employerData?.id, ...data }));
      setLoading(true)
    } else {
      $("#add-edit-employer-loader").removeClass("hidden");
      $("#add_edit_employer").prop("disabled", true);
      dispatch(actionEmployerAdd(data));
      setLoading(true)
    }
  };

  return (
    <>
      <div
        className="modal fade show "
        id="default"
        role="dialog"
        aria-labelledby="employerAddEdit"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="employerAddEdit">
                Employer {props.employerData ? "Edit" : "Add"}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                  <form
                    noValidate
                    autoComplete="Off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-body">
                      <div className="row mb-3">
                        {props.employerData && (
                          <div className="col-6 mb-2">
                            <div className="form-group">
                              <label className="label-control">ID</label>
                              <input
                                className="form-control"
                                id="id"
                                name="id"
                                readOnly
                                {...register("id")}
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">Full Name
                              &nbsp;<span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              id="full_name"
                              name="full_name"
                              readonly
                              {...register("full_name", {
                                required: "This is required",
                              })}
                            />
                            {errors.full_name && (
                              <ErrorLabel message={errors.full_name?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Mobile No&nbsp;<span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="number"
                              id="mobile"
                              name="mobile"
                              maxLength={10}
                              readOnly={props?.employerData ? true : false}
                              onInput={(e) => {
                                if (e.target.value.length > 10) {
                                  e.target.value = e.target.value.slice(0, 10);
                                }
                              }}
                              {...register("mobile", {
                                required: "This is required",
                                pattern: {
                                  value: /^[0-9]{10}$/i,
                                  message: "Invalid mobile number",
                                },
                              })}
                            />
                            {errors.mobile && (
                              <ErrorLabel message={errors.mobile?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Email&nbsp;<span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              id="email"
                              name="email"
                              readOnly={props?.employerData ? true : false}
                              {...register("email", {
                                required: "This is required.",
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: "invalid email address",
                                },
                              })}
                            />
                            {errors.email && (
                              <ErrorLabel message={errors.email?.message} />
                            )}
                          </div>
                        </div>
                        {/* {props.employerData && ( */}
                        <div className="col-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Zone<span className="text-danger">*</span>
                            </label>
                            <div className="form-group">
                              <Controller
                                control={control}
                                name="zone_ids"
                                render={({ field }) => {
                                  return (
                                    <Select
                                      {...field}
                                      placeholder="Select"
                                      menuPlacement={"bottom"}
                                      isMulti={true}
                                      hideSelectedOptions={false}
                                      maxMenuHeight={200}
                                      name="zone_ids"
                                      id='zone_ids'
                                      options={zoneOptions}
                                      value={field.value && field.value !== null ? zoneOptions.filter(option => field.value.includes(option.value)) : ''}
                                      onChange={(selectedOptions) => {
                                        const selectedIds = selectedOptions.map(option => option.value);
                                        field.onChange(selectedIds);
                                        setSelectedZoneId(selectedIds);
                                      }}
                                    />
                                  );
                                }}
                                rules={{
                                  required: "Please Select Zone",
                                }}
                              />
                              {errors.zone_ids && (
                                <ErrorLabel message={errors.zone_ids?.message} />
                              )}
                            </div>
                          </div>
                        </div>
                        {/* )} */}
                        <div className="col-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Status&nbsp;<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              id="status"
                              defaultValue="active"
                              name="status"
                              placeholder="Select.."
                              {...register("status", {
                                required: "This is required.",
                              })}
                            >
                              <option value="ACTIVE">Active</option>
                              <option value="INACTIVE">Inactive</option>
                            </select>
                            {errors.status && (
                              <ErrorLabel message={errors.status?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-6 mb-2">
                          <div className="form-check">
                            <label> Is Super Admin</label>
                            <input className="form-check-input" type="checkbox"
                              id='is_superuser'
                              name='is_superuser'
                              {...register('is_superuser')}
                            >
                            </input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-actions border-0 float-none mt-1">
                      {
                        loading ?
                          <button
                            id="add_edit_employer"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                              <span
                                id="add-edit-employer-loader"
                                className="spinner-border spinner-border-sm ml-half hidden"
                              ></span>
                            </div>
                          </button>
                          :
                          <button
                            id="add_edit_employer"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                            </div>
                          </button>
                      }
                      <button
                        className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                        onClick={(event) => {
                          props.handleClose();
                          event.preventDefault();
                        }}
                      >
                        {" "}
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployerAddEdit;
